import React from 'react';
import Typography from '@material-ui/core/Typography';

export default({children})=>{

 
  return(
    <Typography variant="subtitle1" gutterBottom>
        {children}
     </Typography>
  )
}
